// src/app/App.jsx
import React, { lazy, Suspense, useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Outlet,
} from "react-router-dom";
import ScrollToTop from "../components/ui/ScrollToTop";
import FloatingControls from "../components/layout/FloatingControls";
import { useLang } from '../hooks/useLang';

// Lazy load pages
import Inicio from "../pages/Home"; // Eager load for LCP optimization
const Nosotros = lazy(() => import("../pages/About"));
const Servicios = lazy(() => import("../pages/Services"));
const Portafolio = lazy(() => import("../pages/Portfolio"));
const Blog = lazy(() => import("../pages/Blog"));
const Contacto = lazy(() => import("../pages/Contact"));
import Navbar from "../components/layout/Navbar";
const Footer = lazy(() => import("../components/layout/Footer"));

// Layout principal
const PageLayout = () => (
  <div className="grupo-bloques">
    <Outlet />
  </div>
);

function App() {
  const { lang } = useLang();

  useEffect(() => {
    const handleContextMenu = (event) => event.preventDefault();

    const handleKeyDown = (event) => {
      if (
        (event.ctrlKey || event.metaKey) &&
        (event.shiftKey || event.altKey) &&
        (event.keyCode === 73 || event.keyCode === 86 || event.keyCode === 67)
      ) {
        // Ctrl+Shift+I, Ctrl+U, Ctrl+C
        event.preventDefault();
        alert("El inspector está deshabilitado por seguridad.");
      }
    };

    document.addEventListener("contextmenu", handleContextMenu);
    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("contextmenu", handleContextMenu);
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  const getBasename = () => {
    const path = window.location.pathname;
    if (path.startsWith("/en")) return "/en";
    if (path.startsWith("/es")) return "/es";
    return "/";
  };

  return (
    <Router basename={getBasename()}>
      <div key={lang} className="app-container-transition">
        <ScrollToTop />
        <Navbar />
        <FloatingControls />
        <main>
          <Suspense
            fallback={<div className="cargando">Cargando contenido...</div>}
          >
            <Routes>
              <Route element={<PageLayout />}>
                <Route path="/" element={<Inicio />} />
                <Route path="/nosotros" element={<Nosotros />} />
                <Route path="/servicios" element={<Servicios />} />
                <Route path="/portafolio" element={<Portafolio />} />
                <Route path="/blog" element={<Blog />} />
                <Route path="/contacto" element={<Contacto />} />
              </Route>
            </Routes>
          </Suspense>
        </main>
        <Suspense fallback={null}>
          <Footer />
        </Suspense>
      </div>
    </Router>
  );
}

export default App;
